module.exports = "/v2/pages/dashboard/dist/9751acdf5e9404c4368aa6fde52dc78c.svg";